import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../service/session.service';
import { MessageService } from 'services/message.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private router: Router,
    private messageService: MessageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userId = this.sessionService.getUserId();
    const paymentStatus = userId ? this.sessionService.getPaymentStatus(userId) : null;

    if (userId && paymentStatus && paymentStatus.isPaymentCompleted) {
      return true;
    } else {
      this.messageService.showErrorMessage('Payment not completed. Please complete payment first.');
      return this.router.createUrlTree([`/qrcode/${route.params.codedChargingStationID}/${route.params.codedConnectorID}/payment`]);
    }
  }
}